export default "__VITE_ASSET__iwezvbKn__"